import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import PouchDB from 'pouchdb';


@Injectable()

export class PouchdbProvider {

    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();

    constructor(public http: HttpClient) 
    {       
        if(!this.isInstantiated) {
            
            this.database = new PouchDB("localdb");
            this.isInstantiated = true;
           
        }
    }

    public fetch() {
        return  this.database.allDocs({
                    include_docs: true, 
                    limit:50, 
                    descending: true
                });
    }

    // public get(id: string) {
    //     return this.database.get(id);
    // }

    // public put(document: any, id: string) {
    //     document._id = id;
    //     return this.get(id).then(result => {
    //         document._rev = result._rev;
    //         return this.database.put(document);
    //     }, error => {
    //         if(error.status == "404") {
    //             return this.database.put(document);
    //         } else {
    //             return new Promise((resolve, reject) => {
    //                 reject(error);
    //             });
    //         }
    //     });
    // }

    public sync(remote: string) {
        let remoteDatabase = new PouchDB(remote);
        this.database.sync(remoteDatabase, {
            live: true,
            retry: true,
            batch_size:1,
            batches_limit:1
        }).on('change', change => {
            this.listener.emit(change);
        }).on('error', error => {
            console.error(JSON.stringify(error));
        });
    }

    public getChangeListener() {
        return this.listener;
    }

}



// WEBPACK FOOTER //
// ./src/providers/pouchdb/pouchdb.ts